var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c('div',{staticClass:"control-element__button",domProps:{"innerHTML":_vm._s(_vm.localSettings.label || 'Button')},on:{"click":function($event){$event.stopPropagation();return _vm.openSettings($event)}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }